import { Navigate, Outlet } from "react-router-dom";
import { isLoggedIn } from "../services/AuthStorage";

const PrivateRoute = () => {
  const isAuthenticated = isLoggedIn();
  return isAuthenticated ? <Outlet /> : <Navigate to="/login-register" replace />;
};

export default PrivateRoute;
